// The learn wire shapes, from one place. Everything under lib/learn imports the
// contract through here, so the PWA's view of packages/contract/src/learn.ts is
// a single list of names (and the grammar underneath is @proef/domain's).
export {
  ACADEMY_PATH_FLAG_KEY,
  AcademyPathFlagPayload,
  CheckValue,
  ClaimLearnProgressResponse,
  DrillsDue,
  DrillValue,
  IDENTITY_HEADER,
  IdentityId,
  LearnExport,
  LearnProgress,
  LearnPutRefused,
  LevelValue,
  ProgressItem,
  ProgressKey,
  PROGRESS_ITEM_VALUE_MAX_BYTES,
  PROGRESS_MAX_BODY_BYTES,
  PROGRESS_MAX_ITEMS,
  SHOP_ITEMS_PER_PUT_MAX,
  ShopValue,
  PutProgressRequest,
  StepValue,
  TastingFlightRef,
} from "@proef/contract";
export { checkKey, drillKey, levelKey, stepKey } from "@proef/domain";

import { ListTastingsResponse, Tasting } from "@proef/contract";
import { z } from "zod";

/** `GET /v1/tastings?include=flight`: the journal plus the learner's own flight notes. */
export type LearnTasting = z.infer<typeof Tasting>;
export const ListLearnTastingsResponse = ListTastingsResponse;
export type ListLearnTastingsResponse = z.infer<typeof ListLearnTastingsResponse>;
